
import PrismicData from '~/assets/js/prismic-controller.js'
import BlogWidget from '~/components/blog/BlogWidget.vue'
import BlogNavbar from '~/components/blog/BlogNavbar.vue'
import BlogPagination from '~/components/blog/BlogPagination.vue'
import BlogSearchBar from '~/components/blog/BlogSearchBar.vue'

export default {
  name: 'Category',
  components: {
    BlogWidget,
    BlogNavbar,
    BlogPagination,
    BlogSearchBar
  },
  async asyncData({ $prismic, app, params, query, store, error, req }) {
    const lang = app.i18n.locales.filter((i) =>
      i.iso.includes(app.i18n.locale)
    )[0].iso
    try {
      const response = await $prismic.api.query(
        $prismic.predicates.at('document.type', 'blog_category'),
        { lang, orderings: '[my.blog_category.uid]' }
      )
      const categories = response.results
      const category = categories.find(c => c.uid === params.category)

      /* Alt Lang */
      function getAltLangNav(altLanguages) {
        return altLanguages.map((item) => {
          const lang = item.lang.substr(0, 2)
          return {
            [lang]: {
              category: item.uid,
            },
          }
        })
      }
      if (category.alternate_languages.length) {
        const altLang = getAltLangNav(category.alternate_languages)
        store.dispatch(
          'i18n/setRouteParams',
          altLang.reduce((a) => a)
        )
      }


      const posts = await $prismic.api.query(
        [
          $prismic.predicates.at('document.type', 'post'),
          $prismic.predicates.at('my.post.category', category.id)
        ],
        {
          lang,
          orderings: '[my.post.date desc]',
          pageSize: 100,
          page: query.p || 1,
          fetchLinks: 'blog_category.name',
        }
      )

      return {
        document: category.data,
        posts: posts.results,
        documentUid: category.uid,
        documentLang: category.lang.substr(0, 2),
        categories: categories,
        pages: posts.total_pages,
      }
    } catch (e) {
      error({ message:  JSON.stringify(e),statusCode: 404 })
    }
  },
  head() {
    return PrismicData.seo(this.$nuxtI18nHead({ addSeoAttributes: true }), 
      this.document,
      'blog/' + this.documentUid,
      this.documentLang,
      this.document.name
    )
  },
  watchQuery: ['p'],
}
